import React from 'react';
import { motion } from 'framer-motion';
import { subjects } from '../data/flashcards';
import './SubjectSelector.css';

const SubjectSelector = ({ selectedSubject, onSubjectChange, onStartStudying }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const cardVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 24
      }
    }
  };

  return (
    <div className="subject-selector">
      <motion.div 
        className="selector-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1>Choose Your Subject</h1>
        <p>Select a subject to start studying with flashcards</p>
      </motion.div>

      <motion.div 
        className="subjects-grid"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {subjects.map((subject) => (
          <motion.div
            key={subject.key}
            className={`subject-card ${selectedSubject === subject.key ? 'selected' : ''}`}
            variants={cardVariants}
            whileHover={{ scale: 1.05, y: -5 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => onSubjectChange(subject.key)}
            style={{ '--subject-color': subject.color }}
          >
            <div className="subject-icon">{subject.icon}</div>
            <h3 className="subject-name">{subject.name}</h3>
            <div className="subject-stats">
              <span className="card-count">10 cards</span>
            </div>
            {selectedSubject === subject.key && (
              <motion.div 
                className="selected-indicator"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ type: "spring", stiffness: 400, damping: 25 }}
              >
                ✓
              </motion.div>
            )}
          </motion.div>
        ))}
      </motion.div>

      {selectedSubject && (
        <motion.div 
          className="start-section"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <motion.button
            className="start-studying-btn"
            onClick={onStartStudying}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Start Studying {subjects.find(s => s.key === selectedSubject)?.name}
          </motion.button>
        </motion.div>
      )}

      <motion.div 
        className="all-subjects-option"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.7 }}
      >
        <motion.button
          className="all-subjects-btn"
          onClick={() => {
            onSubjectChange('all');
            onStartStudying();
          }}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          📚 Try All Cards (40 cards)
        </motion.button>
      </motion.div>
    </div>
  );
};

export default SubjectSelector; 